<template>
  <div class="content">
    <div class="title">
      <span class="person">个人档案</span>
      <el-button size="mini" style="background-color: rgba(227, 233, 246, 0.05);color: #666;border-radius: 6px;border: 1px solid rgba(153, 153, 153, 0.8);">编辑</el-button>
    </div>
    <div class="base-info">
      <div class="base-info-left">
        基本信息
      </div>
      <div class="base-info-center">
        <div>
          <p><span>姓名：{{baseInfo.name}}</span></p>
          <p><span>性别：{{baseInfo.sex==1?'男': '女'}}</span></p>
          <p><span>年龄：{{baseInfo.age}}</span></p>
        </div>
        <div>
          <p><span>民族：{{baseInfo.nation}}</span></p>
          <p class="nowrap"><span>籍贯：{{baseInfo.address}}</span></p>
          <p><span>电话：{{baseInfo.phone}}</span></p>
        </div>
        <div>
          <p><span>学历：{{printEducation(baseInfo.eduType)}}</span></p>
          <p><span>专业：{{baseInfo.specialty}}</span></p>
          <p><span>证书：</span>
          <span v-if="baseInfo.certificate" style="text-decoration: underline;cursor: pointer;color: #4D6EB1;">点击查看</span>
          <span v-else>暂无</span>
          </p>
        </div>
        <div>
          <p><span>岗位资格：{{baseInfo.jobPost}}</span></p>
          <p><span>从业年限：{{baseInfo.workYear?baseInfo.workYear+'年':''}}</span></p>
          <p><span>健康状况：{{baseInfo.health}}</span></p>
        </div>
      </div>
      <div class="base-info-right">
        <div></div>
      </div>
    </div>
    <div class="specific">
      <div class="specific-title">在职情况</div>
      <el-table :data="onJob" border>
        <el-table-column label="项目名称" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.projectName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="班组" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.teamName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="出勤" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.days}}天</span>
          </template>
        </el-table-column>
        <el-table-column label="劳务工资" align="center">
           <template slot-scope="scope">
              <span>{{scope.row.sumMonthSalary}}</span>
            </template>
        </el-table-column>
        <el-table-column label="入职时间" align="center">
           <template slot-scope="scope">
             <span>{{scope.row.createDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="离职时间" align="center">
           <template slot-scope="scope">
            <span>{{scope.row.updateDate}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <div class="specific">
      <div class="specific-title">工作记录</div>
      <el-table :data="attendData" border>
        <el-table-column label="总出勤天数" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.day}}</span>
          </template>
        </el-table-column>
        <el-table-column label="总出勤时间" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.time}}</span>
          </template>
        </el-table-column>
        <el-table-column label="出勤率" align="center">

        </el-table-column>
      </el-table>
    </div>
     <div class="specific">
      <div class="specific-title">安全教育记录</div>
      <el-table border>
        <el-table-column label="试卷名称" align="center">

        </el-table-column>
        <el-table-column label="测试得分" align="center">

        </el-table-column>
        <el-table-column label="测试时长" align="center">

        </el-table-column>
        <el-table-column label="是否通过" align="center">

        </el-table-column>
      </el-table>
    </div>
     <div class="specific">
      <div class="specific-title">奖惩记录</div>
      <el-table border>
        <el-table-column label="所属项目" align="center">

        </el-table-column>
        <el-table-column label="事项" align="center">

        </el-table-column>
        <el-table-column label="事项描述" align="center">

        </el-table-column>
        <el-table-column label="时间" align="center">

        </el-table-column>
      </el-table>
    </div>
    <div class="specific">
      <div class="specific-title">工作经历</div>
      <el-table border>
        <el-table-column label="公司名称" align="center">

        </el-table-column>
        <el-table-column label="当前项目" align="center">

        </el-table-column>
        <el-table-column label="班组" align="center">

        </el-table-column>
        <el-table-column label="岗位" align="center">

        </el-table-column>
        <el-table-column label="时间" align="center">

        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        id: '',
        projectId: '',
        baseInfo: {},         // 基本信息
        eduTypes: [           //学历列表
          { id: '1', name: '小学' },
          { id: '2', name: '初中' },
          { id: '3', name: '高中' },
          { id: '4', name: '中专' },
          { id: '5', name: '大专' },
          { id: '6', name: '本科' },
          { id: '7', name: '硕士' },
          { id: '8', name: '博士' },
          { id: '99', name: '其他' }
        ],
        onJob: [],     // 在职情况
        attendData: [],    // 工作记录
      }
    },
    created() {
      const {id, groupId} = this.$route.query
      this.id = id
      this.projectId = groupId
      this.getData()
    },
    mounted() {
      
    },
    methods: {
     getData(){
      myHttp.getPersonByProject2({
        prosonId: this.id,
        projectId: this.projectId
      }).then(resp => {
        console.log(resp);
        if(resp.data.code === 200){
          const data = resp.data.data
          data.baseInfo.age =  data.baseInfo.birthday && data.baseInfo.birthday != '' ? parseInt(new Date().getFullYear()) - parseInt(data.baseInfo.birthday.split('-')[0]) : ''
          this.baseInfo = resp.data.data.baseInfo
          this.onJob = resp.data.data.workLogger
          const total = {
            day: 0,
            time: 0
          }
          this.onJob.forEach(item => {
            total.day += item.days
            total.time += item.workHours
          })
        }else{
          this.$message.error(resp.data.msg)
        }
      })
     },

     // 查询学历
     printEducation(type){
       for(let i=0; i<this.eduTypes.length;i++){
        if(type == this.eduTypes[i].id){
          return this.eduTypes[i].name
        }
       }
     }
    },
  }
</script>

<style scoped>
.content{
  overflow: auto;
}
.title{
  width: 100%;
  height: 5vh;
  display: flex;
  align-items: center;
  background-color: #EBEBEB;
  margin-top: 1vh;
  box-shadow: 0px 4px 10px 0px rgba(140, 168, 225, 0.5);
  border-radius: 6px 6px 0px 0px;
  padding-right: 0.5vw;
}
.person{
  display: inline-block;
  width: 97%;
  text-align: center;
  color: #666666;
  font-size: 24px;
  margin-left: 4vw;
}
.base-info{
  display: flex;
  width: 100%;
  height: 15vh;
  background-color: #ffffff;
	box-shadow: 2px 2px 10px 0px rgba(140, 168, 225, 0.5);
  margin-top: 1vh;
}
.base-info-left{
  height: 100%;
  width: 9%;
  background-color: #EBEBEB;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 20px;
}
.base-info-center{
  height: 100%;
  width: 85%;
  display: flex;
  justify-content: space-between;
  padding: 0 2vw;
}
.base-info-center > div{
  display: flex;
  height: 100%;
  width: 22%;
  flex-direction: column;
  justify-content: space-around;
  text-align: left;
}
.base-info-center > div > p >span:nth-child(1){
  color: #666;
}
.base-info-right{
  width: 10%;
  height: 100%;
  display: flex;
  padding-right: 0.5vw;
  justify-content: flex-end;
  align-items: center;
}
.base-info-right > div{
  height: 100px;
  width: 100px;
  background-color: beige;
}
.specific{
  margin-top: 1vh;
}
.specific-title{
  width: 100%;
  height: 5vh;
  text-align: center;
  line-height: 5vh;
  color: #666;
  background-color: rgba(153, 153, 153, 0.2);
	font-size: 22px;
}
.specific >>> .cell{
  font-size: 1vw;
  color: #666;
}
.specific >>> .el-table__empty-text{
  font-size: 1vw;
}
</style>